/**
 * 只要有一个满足条件就返回 true
 * @param arr
 * @param func
 */
var some = function (arr, func) {
    for (var i = 0; i < arr.length; i++) {
        if (func(arr[i], i))
            return true;
    }
    return false;
};
export default some;
//# sourceMappingURL=some.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/some.js
// module id = 521
// module chunks = 3